import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const HOLIDAY_TYPE_OPTIONS = [
  { id: "New Year", value: "New Year" },
  { id: "Makar Sankranti", value: "Makar Sankranti" },
  { id: "Vasant Panchmi", value: "Vasant Panchmi" },
  { id: "Republic Day", value: "Republic Day" },
  { id: "Holi", value: "Holi" },
  { id: "Independence Day", value: "Independence Day" },
  { id: "Diwali", value: "Diwali" },
  { id: "Christmas", value: "Christmas" },
];

export const fetchHolidayList = async () => {
  const response = await axios.get(`${API_BASE_URL}/holidays`);
  return response.data?.items || [];
};

export const createHoliday = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/holidays`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const deleteHoliday = async (holidayId) => {
  await axios.delete(`${API_BASE_URL}/holidays/${holidayId}`, getAuthConfig());
};
